import { ReactNode } from 'react'
import { cn } from '$components'

export type ModalContentProps = {
  children?: ReactNode,
  className?: string,
}

export function ModalContent({ children, className }: ModalContentProps) {

  return (
    <div className={cn('overflow-y-auto p-6 text-left w-full', className)}>
      { children }
    </div>
  )
}
